import { render, staticRenderFns } from "./PoiDetail.vue?vue&type=template&id=a4d72810&"
import script from "./PoiDetail.vue?vue&type=script&lang=js&"
export * from "./PoiDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports